import React, { useEffect, useCallback, useState} from 'react';
import TrackOverview from './TrackOverview.js';
import {
    connect} from 'react-redux';
import {
    mouseDown
} from 'actions/index.js';


const TracksOverview = ({sequencerEngine, mouseDown, mode, showName}) => { 
    let {tracks} = sequencerEngine;
    if (!tracks || tracks.length === 0) {
        return (<div></div>);
    }
    return (
        <div
          onClick={(e) => e.stopPropagation()}
          onMouseDown={() => mouseDown(true)}
          onMouseUp={() => mouseDown(false)}
          onMouseLeave={() => mouseDown(false)}
          className="tracks-overview">
          {tracks.map(
              track =>
                  <TrackOverview
                    showName={showName}
                    key={track.id}
                    mode={mode}
                    track={track}/>)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      tracks: props.sequencerEngine.tracks,
      numTracks: props.sequencerEngine.tracks && props.sequencerEngine.tracks.length,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      mouseDown: (m) =>
          dispatch(mouseDown(m)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TracksOverview);
